import { formatarComoDecimal, formatarComoMoeda, parseLocaleNumber } from "../../contents/VariaveisGlobais";
import { handleFilaAprovadores } from "./Pedido";
import { handleAbrirPC } from "./Solicitacao";
import { CelBreak25, NormalFont } from "./styles";

function handleFilialNotaFiscal(item, DisparaBootBox, FechaBootBox, navigate){
    const { F1_DOC, F1_SERIE, F1_FORNECE, F1_LOJA, EMPRESA, F1_FILIAL, D1_PEDIDO } = item.row.original;
    const chaveSCR = F1_DOC + F1_SERIE + F1_FORNECE + F1_LOJA

    return (
        <>
            <NormalFont tooltipText={"Fila de Aprovadores"} onClick={(e)=> handleFilaAprovadores("NF", chaveSCR, EMPRESA, F1_FILIAL, DisparaBootBox, FechaBootBox)}><strong>Fil.: </strong>{F1_FILIAL}</NormalFont>
            <br/><NormalFont><strong>NF: </strong>{F1_DOC}</NormalFont>
            <br/><NormalFont><strong>Serie: </strong>{F1_SERIE}</NormalFont>
            {/* { D1_PEDIDO && D1_PEDIDO.trim() && <><br/><NormalFont tooltipText={"Abrir Pedido de Compra"} onClick={()=> handleAbrirPC(EMPRESA, F1_FILIAL, D1_PEDIDO, DisparaBootBox, FechaBootBox)}><strong>PC: </strong>{D1_PEDIDO}</NormalFont></> } */}
        </>
    )
}

function handleUMedidaQtd(item){
    const qtde = formatarComoDecimal(parseLocaleNumber(item.quantidade),4)
    return ( 
        <>
            <p class="d-flex justify-content-between">
                <span>
                    <strong>U.M.: </strong> {item.unidadeMedida}
                </span>
                <span>
                    <strong>Saldo: </strong> {item.saldo}
                </span>
            </p>
            <p>
                <span>
                    <strong>Qtde.: </strong> {qtde}
                </span>
            </p> 
        </>
    )
}

function handlePedidoCompra(item){
    const { finalidade } = item.row.original;

    return ( 
        <>
            <p><strong>Pedido: </strong> {item.pedido} - {item.itemPedido}</p>
            { finalidade && finalidade?.trim() && (<p><strong>Finalidade: </strong> {finalidade}</p>)}
        </>
    )
}

function handleStatusNF(item){ 
    const { F1_APROV, F1_STATUS } = item.row.original
    const aprovFiscal = window._env_?.REACT_APP_APROVA_NF

    return ( F1_STATUS === 'B' && F1_APROV !== aprovFiscal) ? 'Bloqueado por Tolerância' : ( (F1_STATUS === 'B' && F1_APROV === aprovFiscal) || F1_STATUS !== 'B' ) ? item.value : ''
}

function handleUsuarioInclusao(item){
    const { F1_XUSERIN, USRINC } = item.row.original;
    return ( F1_XUSERIN && F1_XUSERIN.trim() ) ? F1_XUSERIN : USRINC
}

function handleFornecedorNFColumn(item){
    const { F1_LOJA, A2_NOME } = item.row.original;
    const usuario = handleUsuarioInclusao(item)

    return ( 
        <>
            <CelBreak25>
                <strong>{item.value.trim()}/{F1_LOJA}</strong> - {A2_NOME.trim()}
            </CelBreak25>
            { usuario && usuario.trim() && (
                <CelBreak25>
                    <strong>Usuário: </strong>{usuario}
                </CelBreak25>) 
            }            
        </>
    )
}

export { handleFilialNotaFiscal, handleUMedidaQtd, handlePedidoCompra, handleFornecedorNFColumn, handleStatusNF, handleUsuarioInclusao }